import { render, staticRenderFns } from "./ApprovedCalls.vue?vue&type=template&id=95b86198&"
import script from "./ApprovedCalls.vue?vue&type=script&lang=js&"
export * from "./ApprovedCalls.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports